import MapboxDraw, { DrawCustomModeThis, DrawFeature, DrawLineString, DrawPoint } from "@mapbox/mapbox-gl-draw";

import { ValidationState } from "fond/draw/validation/helper";
import { LayerIds } from "fond/types";

import * as topologyHelper from "../topologyHelper";

export { getFeatureId } from "../topologyHelper";
export { validLine as validPath } from "../topologyHelper";

/**
 * Underground topology config — binds the shared helpers to the underground path/point layer IDs.
 */
export const undergroundConfig: topologyHelper.TopologyConfig = { lineLayerId: LayerIds.inStreet, pointLayerId: LayerIds.inStreetPoints };

/**
 * Splits an underground path into two segments at the given point location.
 * Delegates to the parameterized topologyHelper with underground layer IDs.
 */
export function splitPaths(this: DrawCustomModeThis, path: DrawLineString, splitPoint: DrawPoint): DrawLineString[] {
  return topologyHelper.splitPaths.call(this, undergroundConfig, path, splitPoint);
}

/**
 * Checks for collocated features (underground paths or points) at the given feature's location.
 * Delegates to the parameterized topologyHelper with underground layer IDs.
 */
export function pullInFeatures(
  this: DrawCustomModeThis,
  feature: DrawFeature,
  connectedIds?: Set<string | number>,
  type?: MapboxDraw.MapMouseEvent["type"]
): { lines: DrawLineString[]; points: DrawPoint[] } {
  return topologyHelper.pullInFeatures.call(this, undergroundConfig, feature, connectedIds, type);
}

/**
 * Retrieves the underground points at the coordinates of a path.
 * Delegates to the parameterized topologyHelper.
 */
export function getPathPoints(this: DrawCustomModeThis, feature: DrawLineString): DrawPoint[] {
  return topologyHelper.getLineEndpointPoints.call(this, undergroundConfig, feature);
}

/**
 * Checks if an underground point feature is snapped to any paths.
 * Delegates to the parameterized topologyHelper.
 */
export function refreshSnappedStatus(this: DrawCustomModeThis, feature: DrawPoint): void {
  topologyHelper.refreshSnappedStatus.call(this, undergroundConfig, feature);
}

/**
 * Deletes features with validation support.
 * Delegates to the parameterized topologyHelper.
 */
export function deleteAndValidate(
  this: DrawCustomModeThis,
  state: ValidationState,
  deleteIds: (string | number)[],
  pointsToRefresh: DrawPoint[]
): void {
  topologyHelper.deleteAndValidate.call(this, undergroundConfig, state, deleteIds, pointsToRefresh);
}
